<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">Tasks</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <b-card no-body>
        <b-card-header>
          <div class="d-flex justify-content-between align-items-center">
            <h3 class="mb-0">Tasks</h3>
            <base-button size="sm" type="default" v-b-toggle.task-sidebar>New</base-button>
          </div>
          <b-row>
            <b-col cols="12" class="d-flex justify-content-center justify-content-sm-between flex-wrap mt-4 px-5"
            >
              <el-select
                class="select-primary pagination-select"
                v-model="filters.status"
                placeholder="All Statuses">
                <el-option
                  class="select-primary"
                  label="All Statuses"
                  value=""
                ></el-option>
                <el-option
                  class="select-primary"
                  v-for="status in statuses"
                  :key="status.value"
                  :label="status.label"
                  :value="status.value"
                >
                </el-option>
              </el-select>
              
              <el-select
                class="select-primary pagination-select"
                v-model="perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </b-col>
          </b-row>
        </b-card-header>
        <loading-panel v-if="loading"></loading-panel>
        <b-table small responsive :items="tasks" :fields="fields" class="w-auto" v-else>
          <template #cell(view)="row">
            <b-button size="sm" variant="primary" @click="taskId = row.item.id" v-b-toggle.task-sidebar><i class="fas fa-eye"></i> View</b-button>
          </template>
          <template #cell(completed)="row">
            <i class="fas fa-check text-success" v-if="row.item.completed"></i>
          </template>
          <template #cell(assigned_to)="row">
            <b-avatar variant="primary" :text="initials(row.item.assigned_to.name)" :src="'https://vapor-us-east-1-1603342423.s3.amazonaws.com/' + row.item.assigned_to.avatar" class="mr-2" v-if="row.item.assigned_to"></b-avatar>
          </template>
        </b-table>
      </b-card>
    </b-container>
    <task :taskId="taskId" @clearTask="clearTask" @getTasks="getTasks"></task>
  </div>
</template>

<script>
import axios from 'axios';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import { mapGetters } from 'vuex';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import errorsMixin from '@/mixins/errors-mixin';
import Task from './Task';
import LoadingPanel from '@/components/LoadingPanel';
import paginationMixin from '@/views/Components/Tables/PaginatedTables/transactionPaginationMixin';
import { Select, Option } from 'element-ui';

export default {
  mixins: [ errorsMixin, paginationMixin ],
  components: {
    RouteBreadCrumb,
    Task,
    LoadingPanel,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      loading: false,
      tasks: [],
      assignedTasks: [],
      fields: [
        {
          key: 'view',
          label: '',
          sortable: false,
          tdClass: 'w-auto'
        },
        {
          key: 'task',
          sortable: false,
          tdClass: 'w-auto'
        },
        {
          key: 'completed',
          sortable: true,
          tdClass: 'w-auto'
        },
        {
          key: 'due_date',
          sortable: true,
          tdClass: 'w-auto'
        },
        {
          key: 'status',
          sortable: true,
          tdClass: 'w-auto'
        },
        {
          key: 'assigned_to',
          sortable: true,
          tdClass: 'w-auto'
        }

      ],
      taskId: null,
      filters: {
        status: '',
        start_date: null,
        end_date: null,
        assignee: '',
      },
      statuses: [
        {
          value: 'active',
          label: 'Active'
        },
        {
          value: 'upcoming',
          label: 'Upcoming'
        },
        {
          value: 'overdue',
          label: 'Overdue00'
        }
      ],
    }
  },
  computed: {
    ...mapGetters({
      userRoute: 'profile/userRoute'
    })
  },
  methods: {
    async getTasks() {
      this.loading = true;
      await axios.get(this.userRoute + "/tasks")
      .then(response => {
        this.tasks = response.data;
        this.loading = false;
      })
      .catch(error => {
        this.error(error);
      });
    },
    async getAssignedTasks() {
      await axios.get(this.userRoute + "/assigned-tasks")
      .then(response => {
        this.assignedTasks = response.data;
      })
      .catch(error => {
        this.error(error);
      });
    },
    initials(assignee) {
      let initials = assignee.split(" ");

      if (initials.length > 1) {
        return initials[0].charAt(0) + initials[1].charAt(0);
      }

      return initials[0].charAt(0);
    },
    clearTask() {
      this.taskId = null;
    }
  },
  created() {
    this.getTasks();
    this.getAssignedTasks();
  }
}
</script>